import React from 'react';
import QaqcPipeRfiFormShared from './QaqcPipeRfiFormShared';

const QaqcPipeRfiFormView: React.FC = () => {
  return <QaqcPipeRfiFormShared mode="view" />;
};

export default QaqcPipeRfiFormView;
